/**
 * @generated SignedSource<<99c0c149981dee791899574d3ecc64f7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingAndReturns_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowReturns_item">;
  readonly " $fragmentType": "PdpSharedShippingAndReturns_item";
};
export type PdpSharedShippingAndReturns_item$key = {
  readonly " $data"?: PdpSharedShippingAndReturns_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingAndReturns_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingAndReturns_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowReturns_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "85b6480df2df411a153ca2fe11cbcf18";

export default node;
